export default "/packs/images/Rosaria-crop~a78e0c18debf05111992492f0701be9a.jpg";